import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  input: {
    width: 458,
    marginTop: 20,
    '& .MuiIconButton-root': {
      fontSize: '1rem',
      color: theme.palette.success.main,
    },
    '& .MuiIconButton-root:hover': {
      color: theme.palette.success.main,
      backgroundColor: 'inherit',
    },
    '& .Mui-disabled': {
      color: theme.palette.gray.efesBorder,
    },
    '& button': {
      fontSize: 18,
    },
    '& input::placeholder': {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  failButtonsSection: {
    marginTop: 20,
    display: 'flex',
    gap: 30,
    [theme.breakpoints.down(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  contained: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: 'inherit',
      border: `1px solid ${theme.palette.success.main}`,
      color: theme.palette.success.main,
    },
  },
  formButton: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    margin: 'unset',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.white.main,
    },
  },
  downloadButton: {
    padding: '10px 22px',
    '&:active': {
      color: theme.palette.primary.pressed,
    },
    [theme.breakpoints.down(1283)]: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:active': {
        color: theme.palette.primary.pressed,
      },
    },
  },
  contractSuccessSubText: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  subText: {
    opacity: 0.6,
    color: theme.palette.gray.efesBorder,
    wordSpacing: 2,
    fontSize: 20,
    marginTop: 20,
    lineHeight: 1.3,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  textCenter: {
    textAlign: 'center',
  },
  statusTitle: {
    textTransform: 'uppercase',
    fontSize: 20,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  loadingText: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,

    '& p': {
      opacity: 0.6,
      color: theme.palette.gray.efesBorder,
      wordSpacing: 2,
      fontSize: 20,
      lineHeight: 1.3,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },

    [theme.breakpoints.down(800)]: {
      flexDirection: 'column-reverse',
    },
  },
  warningStatus: {
    textTransform: 'uppercase',
    color: theme.palette.warning.main,
    fontSize: 20,
    fontWeight: 'bold',
  },
  pdfFailedStatus: {
    '& button': {
      width: '15.5rem',
    },
    '& p': {
      color: theme.palette.error.main,
      width: 'fit-content',
      fontSize: 20,
      marginTop: 20,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
  },
  successScreen: {
    marginTop: 20,
    display: 'flex',
    gap: 50,
    [theme.breakpoints.down(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  messageSection: {
    [theme.breakpoints.down(800)]: {
      textAlign: 'center',
    },
  },
  startNewButton: {
    marginTop: 20,
  },
  table: {
    marginTop: '2rem',
  },
  cardInfoWrapper: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down(1025)]: {
      justifyContent: 'center',
    },
  },
  cardPan: {
    fontSize: 22,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.blue.efesDarkBlue,
    height: 12,
  },
  cardInfo: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  asterisc: {
    fontSize: 26,
    marginRight: 8,
  },
  digits: {
    marginBottom: 10,
    fontWeight: 'bold',
    color: theme.palette.black.main,
  },
  validUntil: {
    color: theme.palette.gray.efesBorder,
    width: 180,
    textAlign: 'left',
    marginLeft: 10,
  },
}));

export default useStyles;
